export default "__VITE_ASSET__Nk9EAahy__"